module.exports = __webpack_public_path__ + "static/link-avoidclickhere-do-c3a41d92936c63a6dea920bc9f0eb401.png";